<template>
  <div id="update-lookups">
    <modal
      name="updateLookups"
      title="Update Lookups"
      class="custom-modal"
      height="auto"
      width="600"
    >
      <template v-slot:content>
        <div class="add-lookups">
          <div>
            <Input
              label="Name"
              class="doctor-input mb-base"
              type="text"
              v-model="name"
            />
            <Input
              label="Type"
              class="doctor-input mb-base"
              type="text"
              v-model="type"
            />
            <Input
              label="Description"
              class="doctor-input mb-base"
              type="text"
              v-model="description"
            />
            <Input
              label="Contact Number"
              class="doctor-input mb-base"
              type="text"
              v-model="contactNumber"
            />
            <Button
              title="Update"
              :loader="loading"
              className="button--primary"
              :onClick="handleUpdate"
            />
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import Button from "@/components/Button";
import Input from "@/components/Input";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Modal,
    Button,
    Input
  },
  data() {
    return {
      lookups: {}
    };
  },
  methods: {
    ...mapActions("doctors", ["updateDoctor"]),
    handleUpdate() {
      this.updateDoctor({
        id: this.lookupDetails.id,
        payload: this.lookups
      }).then(() => {
        this.$modal.hide("updateLookups");
        this.lookups = {};
      });
    }
  },
  computed: {
    ...mapGetters({
      lookupDetails: "doctors/lookupDetails",
      loading: "loading"
    }),
    name: {
      get() {
        return this.lookupDetails.name;
      },
      set(val) {
        this.lookups.name = val;
      }
    },
    type: {
      get() {
        return this.lookupDetails.type;
      },
      set(val) {
        this.lookups.type = val;
      }
    },
    description: {
      get() {
        return this.lookupDetails.description;
      },
      set(val) {
        this.lookups.description = val;
      }
    },
    contactNumber: {
      get() {
        return this.lookupDetails.cell_no;
      },
      set(val) {
        this.lookups.cell_no = val;
      }
    }
  }
};
</script>

<style></style>
